import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import { StringUtil } from 'utils/StringUtil';
import { ActionButton } from 'components/atoms/button';
import { HTMLView } from 'components/atoms/htmlView';
import { Image } from 'components/atoms/image';
import IconCoralRight from 'assets/images/arrowLongRightHighlight.png';
import './styles.scss';

const JoinOurTeamCard = props => {
  const {
    name,
    jobShortDescription,
    listImageUrl,
    thumbNailUrl,
    city,
  } = props.data;

  const croppedDescription = `${StringUtil.formatDescription(
    jobShortDescription,
    25
  )}...`;

  const handleClick = () => {
    console.log('');
  };

  const handleInfoClick = data => {
    const locationPath = props.location;
    RouteUtil.setRouteChange(
      props,
      `/careers/${data.urlSlug}`,
      locationPath.hash,
      locationPath.pathname
    );
  };

  return (
    <div className={'join-our-team-card'}>
      <div className={'card-data'}>
        <div className={'card-image'}>
          <Image
            className={'join-our-team-image'}
            thumbNail={thumbNailUrl}
            src={listImageUrl}
            alt={'our-team-image'}
          />
        </div>
        <div
          className={'info-container'}
          onClick={() => handleInfoClick(props.data)}
        >
          <div className={'info-div'}>
            <p className={'location'}>{city}</p>
            <h3 className={'title'}>{name}</h3>
            <HTMLView
              className={'short-description'}
              html={croppedDescription}
              tagName={'div'}
            />
            <ActionButton
              className={'action-button'}
              onClick={handleClick}
              buttonName={'EXPLORE'}
              iconRight={IconCoralRight}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(JoinOurTeamCard);
